import { useEffect, useState } from 'react';
import automaticBillingHoldService from 'src/services/apiServices/automaticBillingHold/automaticBillingHoldService';

export type AutomaticBillingHoldStatus = {
  manualHoldEnabled: boolean;
  enterpriseOptedIn: boolean;
  facilityUuid?: string | null;
  appliesToFacility: boolean;
};

/**
 * THIN-8063: does the automatic planned-EOC-close billing hold (THIN-8047) apply at the logged-in
 * facility? One read of the backend's own gate (billing-hold toggle AND enterprise opt-in AND
 * facility scope), so the Close-EOC dialog can never disagree with the rule about whether it is in
 * force.
 *
 * `appliesToFacility` is `null` until known and `false` on any failure: an acknowledgement people
 * learn to dismiss is worth nothing, so an unreachable gate shows no dialog rather than a spurious one.
 *
 * @param enabled skip the request entirely while the caller has nothing to gate on it (a closed modal).
 */
const useAutomaticBillingHoldStatus = (enabled: boolean) => {
  const [appliesToFacility, setAppliesToFacility] = useState<boolean | null>(null);
  const facilityId = localStorage.getItem('facilityId') || '';

  useEffect(() => {
    if (!enabled) {
      setAppliesToFacility(null);
      return undefined;
    }
    let cancelled = false;
    automaticBillingHoldService
      .getStatus()
      .then((response: any) => {
        if (cancelled) return;
        const payload: AutomaticBillingHoldStatus | null =
          response?.status === 200 ? response?.data?.data ?? null : null;
        setAppliesToFacility(payload?.appliesToFacility === true);
      })
      .catch(() => {
        if (!cancelled) setAppliesToFacility(false);
      });
    return () => {
      cancelled = true;
    };
  }, [enabled, facilityId]);

  return { appliesToFacility };
};

export default useAutomaticBillingHoldStatus;
